
import * as api from "../../../../api"; 


  
export const createNewSubCourse = (APIData) => async (dispatch)=>{
  try {
      const {data } = await api.createNewSubCourse(APIData);
      // console.log(data)
      if(data){ return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
      
      
   } catch (error) {
     
  }
}
export const createNewMilestone = (APIData) => async (dispatch)=>{
    try {
        const {data } = await api.createNewMilestone(APIData);
        // console.log(data)
        if(data){ return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
        
        
     } catch (error) {
       
    }
}


export const getAllSubCoursesByCourseId = (APIData) => async (dispatch)=>{
  try {
      const {data } = await api.getAllSubCoursesByCourseId(APIData);
    
      if(data){  return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
      
   } catch (error) {
     
  }
}

export const getAllMilestonesBySubCourseId = (APIData) => async (dispatch)=>{
  try {
      const {data } = await api.getAllMilestonesBySubCourseId(APIData);
    
      if(data){  return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
      
   } catch (error) {
     
  }
}




export const reArrangeSubCourses = (APIData) => async (dispatch)=>{
  try {
      const {data } = await api.reArrangeSubCourses(APIData);
    
      if(data){  return data ;}else if(data?.logout){   dispatch({type:"LOGOUT"});}
      
   } catch (error) {
     
  }
}